const map = {
	"./messages.ca_ES.json": 80477,
	"./messages.de_DE.json": 47927,
	"./messages.en_GB.json": 3093,
	"./messages.en_US.json": 64640,
	"./messages.es_ES.json": 93553,
	"./messages.fr_FR.json": 2261,
	"./messages.it_IT.json": 3715,
	"./messages.ja_JP.json": 81052,
	"./messages.ko_KR.json": 26510,
	"./messages.nl_NL.json": 51753,
	"./messages.pl_PL.json": 33633,
	"./messages.pt_PT.json": 70721,
	"./messages.zh_CN.json": 31602
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 820;